import React from 'react';
import TableAnticipoTbody from './TableAnticipoTbodyFull';
import TableAnticipoThead from './TableAnticipoTheadFull';

const TableAnticipoFull = (props) => {
  const { handleEdit } = props;
  const { loadingTables, anticipoFullData } = props.data || {};

  if (!anticipoFullData && !loadingTables) {
    return <div className="p-4 text-center text-gray-500">No hay datos de anticipos disponibles</div>;
  }

  return (
    <div className="overflow-x-auto">
      {!loadingTables && (
        <table className="w-full table-auto text-sm">
          <TableAnticipoThead data={props.data} />
          <TableAnticipoTbody
            endPoint={props.endPoint}
            data={props.data}
            modals={props.modals}
            actions={props.actions}
            handleEdit={handleEdit}
          />
        </table>
      )}
      {loadingTables && <div className="p-4 text-center text-gray-500">Cargando datos...</div>}
    </div>
  );
};

export default TableAnticipoFull;
